/* Treupfote Newsletter: Validierung mit Tippfehler-Hinweis, Kopieren, Rücksprung nach dem Absenden.
   Layout ist reines CSS. Ohne JS greift die native Validierung. */
(() => {
  if (customElements.get('tp-newsletter')) return;
  const DOMAINS = ['gmail.com', 'googlemail.com', 'gmx.de', 'gmx.net', 'gmx.at', 'web.de', 't-online.de', 'yahoo.de', 'yahoo.com', 'outlook.de', 'outlook.com', 'hotmail.de', 'hotmail.com', 'icloud.com', 'me.com', 'freenet.de', 'posteo.de', 'mail.de', 'aol.com'];
  const lev = (a, b) => {
    let p = Array.from({ length: b.length + 1 }, (_, j) => j);
    for (let i = 1; i <= a.length; i++) {
      const c = [i];
      for (let j = 1; j <= b.length; j++) c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      p = c;
    }
    return p[b.length];
  };
  const typo = (v) => {
    const [user, dom] = v.split('@');
    const d = (dom || '').toLowerCase();
    if (!user || !d || DOMAINS.includes(d)) return '';
    const bare = d.indexOf('.') < 0;
    let best = '', bd = 3;
    for (const x of DOMAINS) { const n = lev(d, bare ? x.split('.')[0] : x); if (n < bd) { bd = n; best = x; } }
    return best ? user + '@' + best : '';
  };

  class TpNewsletter extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.t = [];
      this._click = (e) => this.onClick(e);
      this._submit = (e) => this.onSubmit(e);
      this._input = (e) => { if (e.target.matches('.tp-nl__input')) this.clear(); };
      this._show = (e) => { if (e.persisted) this.reset(); };
      this.addEventListener('click', this._click);
      this.addEventListener('submit', this._submit);
      this.addEventListener('input', this._input);
      addEventListener('pageshow', this._show);
      if (this.form) this.form.noValidate = true;
      this.afterPost();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._click);
      this.removeEventListener('submit', this._submit);
      this.removeEventListener('input', this._input);
      removeEventListener('pageshow', this._show);
      this.t.forEach(clearTimeout);
    }
    msg(k) { return this.dataset['msg' + k] || ''; }
    q(s) { return this.querySelector(s); }

    show(text, suggestion) {
      const box = this.q('.tp-nl__error'), out = this.q('[data-tp-nl-msg]'), input = this.q('.tp-nl__input');
      if (!box || !out) return;
      out.textContent = '';
      if (suggestion) {
        const [a, b] = text.split('%s');
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'tp-nl__suggest'; btn.dataset.fix = suggestion; btn.textContent = suggestion;
        out.append(a, btn, b || '');
      } else out.textContent = text;
      box.hidden = false;
      this.form.dataset.invalid = '';
      input.setAttribute('aria-invalid', 'true');
    }
    clear() {
      const box = this.q('.tp-nl__error'), input = this.q('.tp-nl__input');
      if (box) box.hidden = true;
      if (this.form) delete this.form.dataset.invalid;
      if (input) input.removeAttribute('aria-invalid');
    }
    reset() {
      this.busy = false;
      const b = this.q('.tp-nl__btn[type=submit]');
      if (b) { b.disabled = false; b.removeAttribute('aria-busy'); const l = this.q('[data-tp-nl-label]'); if (l && this.label) l.textContent = this.label; }
    }

    onSubmit(e) {
      const input = this.q('.tp-nl__input');
      if (!input || e.target !== this.form) return;
      if (this.busy) { e.preventDefault(); return; }
      const v = input.value.trim();
      let err = '', fix = '';
      if (!v) err = this.msg('Empty');
      else if (this.warned !== v && (fix = typo(v))) { err = this.msg('Typo'); this.warned = v; }
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) err = this.msg('Format');
      if (err) { e.preventDefault(); this.show(err, fix); input.focus(); return; }
      this.busy = true;
      try { sessionStorage.setItem('tp-nl-posted', '1'); } catch (_) {}
      const b = this.q('.tp-nl__btn[type=submit]'), l = this.q('[data-tp-nl-label]');
      if (l) { this.label = l.textContent; l.textContent = this.msg('Busy'); }
      b.setAttribute('aria-busy', 'true');
      requestAnimationFrame(() => { b.disabled = true; });
    }

    onClick(e) {
      const fix = e.target.closest('[data-fix]');
      if (fix) {
        const input = this.q('.tp-nl__input');
        input.value = fix.dataset.fix; this.clear(); input.focus();
        return;
      }
      const btn = e.target.closest('[data-tp-nl-copy]');
      if (btn) this.copy(btn);
    }

    async copy(btn) {
      const code = btn.dataset.code, label = btn.querySelector('[data-tp-nl-copy-label]'), live = this.q('[data-tp-nl-live]'), hint = this.q('[data-tp-nl-hint]');
      let ok = false;
      try { await navigator.clipboard.writeText(code); ok = true; } catch (_) {
        try {
          const r = document.createRange(); r.selectNodeContents(this.q('.tp-nl__code'));
          const s = getSelection(); s.removeAllRanges(); s.addRange(r);
          ok = document.execCommand('copy');
        } catch (_e) { ok = false; }
      }
      if (ok) {
        const orig = label.textContent;
        btn.classList.add('is-copied'); label.textContent = this.msg('Copied');
        if (live) live.textContent = this.msg('Live').replace('%s', code);
        this.t.push(setTimeout(() => { btn.classList.remove('is-copied'); label.textContent = orig; }, 2500));
      } else if (hint) {
        hint.textContent = this.msg('Selected'); hint.hidden = false;
        try { const r = document.createRange(); r.selectNodeContents(this.q('.tp-nl__code')); const s = getSelection(); s.removeAllRanges(); s.addRange(r); } catch (_) {}
      }
    }

    afterPost() {
      if (!this.form) return;
      let posted = false;
      try { posted = sessionStorage.getItem('tp-nl-posted') === '1'; sessionStorage.removeItem('tp-nl-posted'); } catch (_) {}
      if (!posted && location.hash !== '#' + this.form.id) return;
      const ok = this.q('[data-tp-nl-success]'), err = this.q('.tp-nl__error:not([hidden])');
      const box = ok || err, focus = ok ? this.q('[data-tp-nl-focus]') : this.q('.tp-nl__input');
      if (!box) return;
      const go = () => {
        const top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tp-header-h')) || 72;
        const r = (ok || this.form).getBoundingClientRect();
        if (r.top < top || r.bottom > innerHeight) (ok || this.form).scrollIntoView({ block: 'center', behavior: 'auto' });
        if (focus) focus.focus({ preventScroll: true });
      };
      if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
    }
  }
  customElements.define('tp-newsletter', TpNewsletter);
})();